import React from "react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import ProductChips from "features/BuildingProductEditor/components/ProductChips";
import { epdEditorStore } from "../EPDEditorStore";
import { getCurrentReferenceUnitValue } from "features/MappingEditor/utils";

const EPDHeader = () => {
  const { i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const currentRefUnit = getCurrentReferenceUnitValue(
    epdEditorStore.data?.reference_unit
  );

  return (
    <div
      className={clsx(
        "w-full bg-white px-6 py-3 items-center justify-between bg-gradient-to-r from-pink-50",
        "text-lg font-semibold border-b border-gray-200"
      )}
    >
      <div className="h-7 text-gray-800">{epdEditorStore.data.name || "-"}</div>
      <ProductChips
        refUnit={isEng ? currentRefUnit?.name : currentRefUnit?.name_de}
        conformity={[epdEditorStore.data.conformity_name]}
        hideCertifications
        hideIfEmpty
      />
    </div>
  );
};

export default observer(EPDHeader);
